import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _isNumber from "lodash/isNumber";
import _get from "lodash/get";
import _assign from "lodash/assign";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Promise from 'promise';
import { validateType, validateWhitelist } from '../validation/types';
/**
 * Helper to copy/rename size properties to viewConfig
 * @private
 * @param  {Object} inputProps
 * @return {Object}
 */

var getSizeProps = function getSizeProps(inputProps) {
  var map = {
    min: 'minimum',
    max: 'maximum',
    minLength: 'minLength',
    maxLength: 'maxLength'
  };
  return Object.keys(map).reduce(function (acc, key) {
    var prop = _get(inputProps, map[key]);

    if (_isNumber(prop)) {
      acc[key] = prop; // eslint-disable-line no-param-reassign
    }

    return acc;
  }, {});
};
/**
 * Helper to get default viewConfig subType (type of what is passed in events as value)
 * @private
 * @return {String}
 */


var getSubType = function getSubType(_ref) {
  var type = _ref.type;

  switch (type) {
    case 'integer':
    case 'float':
      return 'number';

    case 'string':
    default:
      return 'text';
  }
};
/**
 * Helper to get default viewConfig type
 * @private
 * @return {String}
 */


var getType = function getType(_ref2) {
  var type = _ref2.type;

  switch (type) {
    case 'integer':
      return 'tel';

    default:
      return null;
  }
};
/**
 * Converts provided or default validators to function references
 * @private
 * @return {Object}
 */


var getValidators = function getValidators(_ref3) {
  var type = _ref3.type,
      whitelist = _ref3.whitelist,
      validators = _ref3.validators;
  return validators || [whitelist && type !== 'array' ? validateWhitelist : validateType[type]];
};
/**
 * Helper to get default viewConfig value references
 * @private
 * @param  {String} viewType
 * @return {Object}
 */


var getValueProps = function getValueProps(viewType) {
  switch (viewType) {
    case 'input':
      return {
        value: '{{1}}',
        placeholder: '{{0}}'
      };

    default:
    case 'radio':
    case 'select':
      return {
        value: '{{2}}'
      };
  }
};
/**
 * Helper to get default viewType
 * @private
 * @return {String} Resolved viewConfig.viewType
 */


var getViewType = function getViewType(_ref4) {
  var type = _ref4.type,
      whitelist = _ref4.whitelist;

  if (type === 'boolean' || whitelist) {
    if (whitelist && whitelist.length > 2) {
      return 'select';
    }

    return 'radio';
  }

  return 'input';
};
/**
 * Wrapper to provide default validations and ConfigBuilder viewConfig.
 * @class
 * @example
 * import Input from '@nerdwallet/home-app-lib/input';
 *
 * const myInput = new Input({
 *  name: 'path.to.my.input.data',
 *  type: 'string',
 * });
 */


var Input =
/*#__PURE__*/
function () {
  /**
   * @param {Object} properties
   * @param {String} properties.name Name of the input.  Must be unique
   * @param {String} properties.type Expected type of data; 'integer', 'float', 'boolean', 'string' or 'array'
   * @param {String} [properties.format] Format used for validation messages and `formatType` in ConfigBuilder; 'percentage' or 'currency'
   * @param {Boolean} [properties.required=true] Is the input required?
   * @param {Boolean} [properties.nullable] Input is nullable?
   * @param {Boolean} [properties.sensitive=false] Does the input contain PII?
   * @param {Number} [properties.minimum] Minimum allowed value. Numeric types only.
   * @param {Number} [properties.maximum] Maximum allowed value. Numeric types only.
   * @param {Number} [properties.minLength] Minimum length of string.
   * @param {Number} [properties.maxLength] Maximum length of string.
   * @param {Array} [properties.validators] Override built-in validators. Should be an array of functions.
   * @param {Array} [properties.whitelist] List of allowed values.
   * @param {Object} [properties.viewConfig={}]  Defaults for ConfigBuilder's viewConfig
   */
  function Input(_ref5) {
    var _ref5$viewConfig = _ref5.viewConfig,
        viewConfig = _ref5$viewConfig === void 0 ? {} : _ref5$viewConfig,
        inputProps = _objectWithoutProperties(_ref5, ["viewConfig"]);

    _classCallCheck(this, Input);

    var name = inputProps.name,
        format = inputProps.format,
        sensitive = inputProps.sensitive;
    var viewType = viewConfig.viewType || getViewType(inputProps);

    _assign(this, inputProps, {
      sensitive: sensitive === true,
      // default to false
      validators: getValidators(inputProps),
      viewConfig: _objectSpread({
        viewType: viewType,
        subType: getSubType(inputProps),
        type: getType(inputProps),
        trackingRedactValue: sensitive,
        trackingFieldName: name,
        formatType: format || 'none',
        inputId: name,
        keys: ['defaults', 'manual', 'resolved'].map(function (collection) {
          return {
            update: collection === 'manual',
            key: "".concat(collection, ".").concat(name)
          };
        }),
        getValidationConfig: this.getValidationConfig.bind(this)
      }, getSizeProps(inputProps), getValueProps(viewType), viewConfig)
    });
  }
  /**
   * Helper to get validation status and messages.  Passed to `ConfigBuilder`
   * @param  {Object} data Object passed to ConfigBuilder as `data`
   * @return {Object}      Boolean `isValid` and array of `feedback`
   */


  _createClass(Input, [{
    key: "getValidationConfig",
    value: function getValidationConfig(data) {
      var errors = _get(data, "validations.".concat(this.name), []);

      return {
        isValid: errors.length === 0,
        feedback: errors
      };
    }
    /**
     * Get and optionally override default viewConfig
     * @param  {Object} [overrides={}] Any viewConfig props you want to override for this instance
     * @return {Object} ConfigBuilder's viewConfig
     */

  }, {
    key: "getViewConfig",
    value: function getViewConfig() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread({}, this.viewConfig, overrides);
    }
    /**
     * Runs all validators for the input and returns a {Promise}
     * that resolves with an array of error messages
     *
     * @example
     * myInput.validate(data).then(errorMessages => {
     *  const isValid = errorMessages.length === 0,
     * });
     *
     * @param  {Object} data Object passed to ConfigBuilder as `data`
     * @return {Promise<Array>}     Resolved with an array of error messages
     */

  }, {
    key: "validate",
    value: function validate() {
      var _this = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var value = _get(data, this.name);

      if (this.required === false) {
        if (this.nullable && value === null || value === '' || value === undefined) {
          return Promise.resolve([]);
        }
      }

      return Promise.all(this.validators.map(function (validator) {
        return Promise.resolve(validator(data, _this));
      })).then(function (results) {
        return results.reduce(function (acc, _ref6) {
          var valid = _ref6.valid,
              message = _ref6.message;

          if (!valid) {
            acc.push(message);
          }

          return acc;
        }, []);
      });
    }
  }]);

  return Input;
}();

export { Input as default };